// extracted by mini-css-extract-plugin
export default {"wrapper":"transform-component_wrapper__IE-Yp","content":"transform-component_content__XTKuz"};